import { render, staticRenderFns } from "./CustomLoader.vue?vue&type=template&id=7833b8a4&scoped=true&"
import script from "./CustomLoader.ts?vue&type=script&lang=ts&"
export * from "./CustomLoader.ts?vue&type=script&lang=ts&"
import style0 from "./CustomLoader.scss?vue&type=style&index=0&id=7833b8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7833b8a4",
  null
  
)

export default component.exports